import Register from '../components/auth/register/Register';
 
const PageRegister = () => (<Register/>);
export default PageRegister;